const Genders = [
    { value: 1, text: 'Nam' },
    { value: 0, text: 'Nữ' }
];

const PriorityAreas = [
    { value: 'KV1', text: 'KV1', mark: 0.75 },
    { value: 'KV2', text: 'KV2', mark: 0.25 },
    { value: 'KV2-NT', text: 'KV2-NT', mark: 0.5 },
    { value: 'KV3', text: 'KV3', mark: 0 }
];

const PriorityObjects = [
    { value: '01', text: '01', mark: 2 },
    { value: '02', text: '02', mark: 2 },
    { value: '03', text: '03', mark: 2 },
    { value: '04', text: '04', mark: 2 },
    { value: '05', text: '05', mark: 1 },
    { value: '06', text: '06', mark: 1 },
    { value: '07', text: '07', mark: 1 }
];

const AcademicRanks = [
    { value: 'GIOI', text: 'Giỏi' },
    { value: 'KHA', text: 'Khá' },
    { value: 'TRUNG_BINH', text: 'Trung bình' },
    { value: 'YEU', text: 'Yếu' }
];

const ConductRanks = [
    { value: 'TOT', text: 'Tốt' },
    { value: 'KHA', text: 'Khá' },
    { value: 'TRUNG_BINH', text: 'Trung bình' },
    { value: 'YEU', text: 'Yếu' }
];

const GraduationYears: { value: number, text: number }[] = [];
const currentYear = new Date().getFullYear();
for (let year = currentYear; year > 2000; year--) {
    GraduationYears.push({ value: year, text: year });
}

export { Genders, PriorityAreas, PriorityObjects, AcademicRanks, ConductRanks, GraduationYears };
